// extracted by mini-css-extract-plugin
module.exports = {"InvalidFeedback":"SettlementForm_InvalidFeedback__N1Feq","TotalAmountView":"SettlementForm_TotalAmountView__1lzpd","Description":"SettlementForm_Description__ifHOG"};